(function () {
  function addBusinessDays(date, days) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return result;
  }

  function formatDate(date) {
    return date.toLocaleDateString(document.documentElement.lang || 'en', {
      month: 'short',
      day: 'numeric'
    });
  }

  document.querySelectorAll('[data-tw-delivery-estimate]').forEach(function (el) {
    var minDays = parseInt(el.getAttribute('data-min-days'), 10);
    var maxDays = parseInt(el.getAttribute('data-max-days'), 10);
    var target = el.querySelector('[data-tw-delivery-estimate-dates]');
    if (!target || !minDays || !maxDays) {
      return;
    }
    var today = new Date();
    var minDate = addBusinessDays(today, minDays);
    var maxDate = addBusinessDays(today, maxDays);
    target.textContent = minDays === maxDays
      ? formatDate(maxDate)
      : formatDate(minDate) + '–' + formatDate(maxDate);
  });
})();
